import { Logger } from '@grandstand-web/utils/logger'
import { TAdInfo, TAdIsLat, TDeviceInfo } from '../types'
import { encodeObjectValues } from './encodeObjectValues'
import { getDeviceAdId } from './getDeviceAdId'

const logger = Logger.of('getTizenAdInfo')

export const getTizenAdInfo = (baseDeviceInfo: TDeviceInfo): TAdInfo => {
  const adInfo: TAdInfo = {
    did: baseDeviceInfo.advertisingId ?? getDeviceAdId(),
    is_lat: baseDeviceInfo.isLAT ?? true ? TAdIsLat.TRUE : TAdIsLat.FALSE, // defaults to true if not set
    platform: 'Tizen',
    device_make: baseDeviceInfo.deviceMake ?? 'Samsung',
    device_model: baseDeviceInfo.deviceModel ?? 'SMART-TV',
    osversion: baseDeviceInfo.nativeVersion ?? 'unknown',
  }
  return encodeObjectValues(adInfo)
}
